import dynamic from 'next/dynamic';
import {createTranslator, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/features/hero';
import CandidateSourcingSection from '@/content/features/candidate-sourcing';
import shared from '../messages/en/shared.json';
import features from '../messages/en/features.json';

// Dynamic Content Components import
const ATSVideoSection = dynamic(() => import('@/content/features/ats-video'), {
  loading: () => null
});
const ApplicantTrackingSection = dynamic(() => import('@/content/features/applicant-tracking'), {
  loading: () => null
});
const InformationSystemSection = dynamic(() => import('@/content/features/information-system'), {
  loading: () => null
});
const TimeAndAttendanceSection = dynamic(() => import('@/content/features/time-and-attendance'), {
  loading: () => null
});
const AiSection = dynamic(() => import('@/content/features/ai-section'), {
  loading: () => null
});
const AdditionalFeaturesSection = dynamic(() => import('@/content/features/additional-features'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const FeaturesPage = () => (
  <>
    <HeroSection />
    <ATSVideoSection />
    <CandidateSourcingSection />
    <ApplicantTrackingSection />
    <InformationSystemSection />
    <TimeAndAttendanceSection />
    <AiSection />
    <AdditionalFeaturesSection />
    <PreFooter />
  </>
);

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('features.seo.title'),
    description: t('features.seo.description'),
    canonical: t('features.seo.canonical')
  };
};

export const messagesForIntl = {shared, features};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(FeaturesPage, seoMetas as never);
